<template>
	<footer class="footer pt-5 pb-4">
		<div class="container">
			<div class="row w-100 align-items-center">
				<div class="col-12 col-lg-3">
					Copyright {{ new Date().getFullYear() }} ANGO
				</div>
				<div class="col-12 col-lg-6 d-flex justify-content-lg-center flex-column flex-md-row">
					<a href="/polityka-prywatnosci" class="nav-item nav-link px-0">Polityka prywatności</a>
				</div>
				<div class="col-12 col-lg-3 d-flex justify-content-center justify-content-md-end mt-3 mt-md-0">
					<a href="http://evostudio.pl">
						<img src="/assets/images/evostudio.svg" alt="EvoStudio">
					</a>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'Footer',
		methods: {
			scrollToTop() {
				window.scrollTo(0,0);
			}
		}
	}	
</script>
